<script>
import signModal from '@/common/components/application/form-blocks/SignModal.vue'

export default {
  extends: signModal,
  name: 'SignModal'
}
</script>
